import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getDefaultMobileWidth } from '../../custom-hooks/screen-detector';

import { sanitizeThemeStyleByNumber } from '../../helpers/style';

const MButtonCon = styled.button`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  justify-content: ${props => props.$textAlignment};
  text-align: ${props => props.$textAlignment};
  gap: ${props => props.$gap};
  font-family: ${props => props.$fontFamily} !important;
  background-color: ${props => props.$backgroundColor} !important;
  color: ${props => props.$textColor};
  border: ${props => props.$borderWidth}px solid ${props => props.$borderColor};
  border-radius: ${props => props.$borderRadius}px;
  font-weight: ${props => props.$fontWeight};
  font-size: ${props => props.$fontSize}px;
  text-decoration: ${props => props.$textDecoration};
  font-style: ${props => props.$fontStyle};
  padding: ${props => props.$padding} !important;
  margin: ${props => props.$margin};
  height: ${props => props.$height}px;
  width: ${props => props.$width};
  opacity: ${props => (props.opacity ? props.opacity : '1')};

  &:hover {
    background-color: ${props => props.$backgroundColor} !important;
    color: ${props => props.$textColor} !important;
    border: ${props => props.$borderWidth}px solid
      ${props => props.$borderColor} !important;
    border-radius: ${props => props.$borderRadius}px !important;
  }

  &:disabled {
    cursor: not-allowed;
  }

  @media (max-width: ${getDefaultMobileWidth()}px) {
    font-size: ${props => props.$mobileFontSize}px;
  }
`;

export const MButton = ({
  children,
  onClick,
  buttonStyle = 'filled',
  backgroundColor = '#000000',
  fontSize,
  mobileFontSize,
  textColor = '#ffffff',
  borderRadius = '4',
  borderColor = backgroundColor,
  borderWidth = '1',
  fontStyle = 'normal',
  textDecoration = 'none',
  fontWeight = 'normal',
  textAlignment,
  fontFamily = 'inherit',
  padding,
  margin,
  height,
  width,
  gap = '4px',
  disabled,
  attributes = {},
  className = '',
  opacity,
}) => (
  <MButtonCon
    type="button"
    onClick={onClick}
    className={`${className} mr-button`}
    $textColor={textColor}
    $backgroundColor={
      buttonStyle === 'filled' ? backgroundColor : 'transparent'
    }
    $fontSize={fontSize}
    $mobileFontSize={mobileFontSize}
    $borderRadius={borderRadius}
    $borderColor={buttonStyle !== 'text' ? borderColor : 'transparent'}
    $borderWidth={borderWidth}
    $fontStyle={fontStyle}
    $textDecoration={textDecoration}
    $textAlignment={textAlignment}
    $fontWeight={fontWeight}
    $fontFamily={fontFamily}
    $padding={padding}
    $margin={margin}
    $height={height}
    $width={sanitizeThemeStyleByNumber(width)}
    $gap={gap}
    disabled={disabled}
    opacity={opacity}
    data-mr-input
    {...attributes}
  >
    {children}
  </MButtonCon>
);

MButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.any,
  icon: PropTypes.any,
  text: PropTypes.string,
  buttonStyle: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  fontSize: PropTypes.string,
  mobileFontSize: PropTypes.string,
  borderRadius: PropTypes.string,
  borderColor: PropTypes.string,
  borderWidth: PropTypes.string,
  fontStyle: PropTypes.string,
  textDecoration: PropTypes.string,
  fontWeight: PropTypes.string,
  textAlignment: PropTypes.string,
  fontFamily: PropTypes.string,
  padding: PropTypes.string,
  margin: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  gap: PropTypes.string,
  disabled: PropTypes.bool,
  attributes: PropTypes.object,
  className: PropTypes.string,
  opacity: PropTypes.string,
};
